import React from "react";
import {
  Box,
  Stack,
  Grid,
} from "@mui/material";
const InventoryPdf = React.forwardRef((props, ref) => {
  console.log("props", props);
  const [wgtUm] = React.useState(props.wgtUm)
  const [row] = React.useState(props.data)
  const [filter] = React.useState(props.filter)


  return (
    <div ref={ref}>

      <Stack spacing={2} >
        <Box
          sx={{
            display: 'none',
            displayPrint: 'block',

            fontSize: '16pt',
            fontWeight: '700',
            textAlign: "center"
          }}
        >
          Inventory Status
        </Box>
        <Grid container sx={{ padding: "5px", border: "2px solid" }} spacing={1} direction="row" >
          {Object.keys(filter).map((k) =>

            <Grid item xs={6}  >{k + " : " + filter[k]}</Grid>
          )
          }

        </Grid>
        <Grid container sx={{ padding: "5px", border: "2px solid" }} spacing={1} direction="row" >

          <Grid item xs={2}  > Status Codes:</Grid>

          <Grid item xs={10}>
            <Grid container spacing={1}>
              <Grid item xs={3} >1 - Ready to Ship</Grid>
              <Grid item xs={3} >2 - Quality Hold</Grid>
              <Grid item xs={3} >3 - Hold for Under weight</Grid>
              <Grid item xs={3} >4 - NSEP</Grid>
              <Grid item xs={3} >6 - Hold to Re-work</Grid>
              <Grid item xs={3} >7 - Master - Ready to Process</Grid>
              <Grid item xs={3} >B - Presource</Grid>
              <Grid item xs={3} >R - Re-applied to Secondary</Grid>
            </Grid>



          </Grid>
          <Grid item xs={2} >Reservation Codes:</Grid>

          <Grid item xs={10} >
            <Grid container spacing={1}>
              <Grid item xs={3} >U - Unallocated</Grid>
              <Grid item xs={3} >O - Allocated to Toll Order</Grid>
              <Grid item xs={3} >B - Allocated to an Advance Load</Grid>
              <Grid item xs={3} >T - Transient Material</Grid>
              <Grid item  >P - Material in process of being updated after production</Grid>

            </Grid>



          </Grid>






        </Grid>
      </Stack>

      <div className="spacing"></div>
      <table>
        
        <tr>
          <th>Part Number</th>
          <th>Mill Order Number</th>
          <th>End-User PO</th>
          <th>Mill Coil ID</th>
          <th>Proc. Coil ID</th>
          <th className="leftAlign">{wgtUm}</th>
          <th className="leftAlign">Pieces</th>
          <th>Gauge</th>
          <th className="leftAlign">Width</th>
          <th className="leftAlign">Length</th>
          <th>Sts</th>
          <th>Rsv</th>
          <th>Date</th>
        </tr>
        {row.map((row, key) =>
             <tr className={  row.isTot === 1 ? "bold":''}>
              <td >{row.partNo}</td>
              <td>{row.cusPoNo}</td>
              <td>{row.eusrPoNo}</td>
              <td>{row.cusTagNo}</td>
              <td>{row.procrCoilStf}</td>

              <td className="leftAlign">{row.wgtStr}</td>
              <td  className="leftAlign">{row.pcsStr}</td>
              <td>{row.gaStr}</td>
              <td className="leftAlign">{row.wdthStr}</td>
              <td className="leftAlign">{row.lgthStr}</td>
              <td>{row.stsDesc}</td>
              <td>{row.invtTypDesc}</td>
              <td>{row.origRefDts}</td>
            </tr>
          



        )}

      </table>



    </div>
  );
});

export default InventoryPdf;
